"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../schema");
const value = schema_1.Schema.number()
    .unit("g/L")
    .precision(1)
    .min(5)
    .max(90)
    .interpretation({ vocab: "htx", code: "serum_albumin" })
    .tag({ vocab: "loinc", code: "1751-7" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ value });
